export default __webpack_public_path__ + "static/media/ic_caret_black.72794c1c.svg";